export default {
  gamuda: {
    disabledSignUpText: "Don't have an account? Please activate Live Chat with our Relationship Associate before booking"
  },
  sunway: {
    disabledSignUpText: ""
  },
  default: {
    disabledSignUpText: ""
  },
};
